import {
  ComponentOrReferenceFormattingRule,
  FormattingColorPicker,
  ColorPickerWrapper,
  type Formatting,
  type FormattingContextState,
  buildColorWarningKey,
} from '@ardoq/perspectives';
import { RuleValueInput } from '@ardoq/query-builder';
import { RowHeader } from '../../../atoms';
import { BottomRowWrapper } from './atoms';

type FormattingRuleSingleRowColorAndValueEditorsProperties = {
  rule: ComponentOrReferenceFormattingRule;
  filter: Formatting;
  formattingContext: FormattingContextState;
  colorPaletteAlignment: 'left' | 'right';
};
const FormattingRuleDoubleRowColorAndValueEditors = ({
  rule,
  filter,
  formattingContext,
  colorPaletteAlignment,
}: FormattingRuleSingleRowColorAndValueEditorsProperties) => {
  const { __id: ruleId, value, field, comparator, color } = rule;
  const { filterType } = filter;
  const { asyncSuggestionsLoaders, asyncLabelLoaders, updateRule, ruleInfo } =
    formattingContext;
  const { colorWarnings = {} } = ruleInfo[ruleId] || {};
  const colorWarning = colorWarnings[buildColorWarningKey(rule.color)];

  return (
    <>
      <RowHeader>Value</RowHeader>
      {filterType && comparator && (
        <RuleValueInput
          key={field}
          operator={comparator}
          asyncSuggestionsLoaders={asyncSuggestionsLoaders}
          asyncLabelLoaders={asyncLabelLoaders}
          filterType={filterType}
          filter={filter}
          // Formatting rules fallback to null, but null is not a valid value for this input type. undefined is.
          value={value ?? undefined}
          onValueChange={value =>
            updateRule(ruleId, {
              value: Number.isNaN(value) ? null : value,
            })
          }
          locale={formattingContext.locale}
          hasWarning={Boolean(colorWarning)}
          hideWarningIcon={!colorWarning}
          menuPortalTarget={null}
        />
      )}
      <RowHeader>Color</RowHeader>
      <BottomRowWrapper>
        <ColorPickerWrapper $hasWarning={Boolean(colorWarning)}>
          <FormattingColorPicker
            dataTestId="formatting-rule-color-picker"
            value={color}
            onValueChange={color => updateRule(ruleId, { color })}
            colorPaletteAlignment={colorPaletteAlignment}
            isNewConditionalFormatting={true}
          />
        </ColorPickerWrapper>
      </BottomRowWrapper>
    </>
  );
};
export { FormattingRuleDoubleRowColorAndValueEditors };
